import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { IMAGE_URL } from "../../../api-urls";

const ImageModal = ({
  isOpen,
  handleCloseModal, // Changed from handleClose to handleCloseModal
  bigImage,
  smallImages,
  clickedItem,
  handleImageClick,
  handleNextBig,
  handlePrevBig,
  icons,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Update currentIndex when bigImage changes
  useEffect(() => {
    const index = smallImages.findIndex((img) => img === bigImage);
    setCurrentIndex(index !== -1 ? index : 0);
  }, [bigImage, smallImages]);

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % smallImages.length;
    setCurrentIndex(newIndex);
    handleImageClick(smallImages[newIndex], newIndex, clickedItem);
    handleNextBig();
  };

  const handlePrev = () => {
    const newIndex = (currentIndex - 1 + smallImages.length) % smallImages.length;
    setCurrentIndex(newIndex);
    handleImageClick(smallImages[newIndex], newIndex, clickedItem);
    handlePrevBig();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-tertiary w-[98%] h-full relative flex">
        {/* Close Button */}
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent event bubbling
            handleCloseModal(); // Updated to handleCloseModal
          }}
          className="absolute top-4 right-4 text-3xl font-bold text-gray-800 hover:text-gray-600 z-50"
        >
          ×
        </button>

        {/* Left Section: Small Images */}
        <div className="w-1/4 h-full overflow-y-auto p-4 flex flex-col gap-4">
          {smallImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className={`w-[90%] h-auto object-cover cursor-pointer border-2 ${
                currentIndex === index ? "border-primary1" : "border-gray-300"
              }`}
              onClick={() => {
                setCurrentIndex(index);
                handleImageClick(image, index, clickedItem);
              }}
            />
          ))}
        </div>

        {/* Right Section: Big Image with Navigation Arrows */}
        <div className="w-3/4 h-full relative flex items-center justify-center">
          {/* Previous Arrow */}
          <button
            onClick={handlePrev}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-3xl font-bold text-gray-800 hover:text-gray-600"
          >
            {"<"}
          </button>

          {/* Big Image */}
          <img
            src={bigImage}
            alt="Big Dress"
            className="max-w-full max-h-full object-contain"
          />

          {/* Next Arrow */}
          <button
            onClick={handleNext}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-3xl font-bold text-gray-800 hover:text-gray-600"
          >
            {">"}
          </button>
        </div>
      </div>
    </div>
  );
};

ImageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired, // Updated to handleCloseModal
  bigImage: PropTypes.string,
  smallImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  clickedItem: PropTypes.object,
  handleImageClick: PropTypes.func.isRequired,
  handleNextBig: PropTypes.func.isRequired,
  handlePrevBig: PropTypes.func.isRequired,
  icons: PropTypes.object.isRequired,
};

export default ImageModal;